import { useEffect } from 'react';
import './TermsPage.css';

function TermsPage() {
  useEffect(() => {
    // Load Termly script
    if (!document.getElementById('termly-jssdk')) {
      const script = document.createElement('script');
      script.id = 'termly-jssdk';
      script.src = 'https://app.termly.io/embed-policy.min.js';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="terms-page">
      <div 
        data-name="termly-embed" 
        data-id="0f06bd8d-18f7-48d4-8cef-6c92dd0969d8"
        ref={(el) => el?.setAttribute('name', 'termly-embed')}
      />
    </div>
  );
}

export default TermsPage;
